import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import {TIME_FORMAT} from "config/constants";
import {Destination, Route} from "v2/api/Records";

const DestinationEstStartTime = (props, context) => {
  const {routeData: {overlappedDestinations}} = context;
  const {data: {estStartTime, id}} = props;

  const isOverlapped = overlappedDestinations.includes(id);
  const className = classnames({
    [props.className || ""]: true,
    "text-warning": isOverlapped,
  });
  const title = isOverlapped ?
    "Start time overlaps previous Destination end time." :
    null;

  return (
    <strong className={className} title={title}>
      {isOverlapped &&
        <i className="fa fa-exclamation-triangle erg-margin-right-5" />}
      {estStartTime.format(TIME_FORMAT)}
    </strong>
  );
};

DestinationEstStartTime.contextTypes = {
  routeData: PropTypes.instanceOf(Route),
};
DestinationEstStartTime.propTypes = {
  className: PropTypes.string,
  data: PropTypes.instanceOf(Destination).isRequired,
};

export default DestinationEstStartTime;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationEstStartTime.js
 **/